import Utils from 'services/utils';

function responseDataExtractor(response) {
    return response.data;
}

export default class FoldersApi {
    /** @ngInject */
    constructor($http) {
        this.$http = $http;
        this.listUrl = Utils.buildApiUrl('folders.list');
    }

    fetch(params) {
        return this.$http.get(this.listUrl, { params }).then(responseDataExtractor);
    }

    create(data) {
        return this.$http.post(this.listUrl, data).then(responseDataExtractor);
    }

    update(folderId, data) {
        const url = Utils.buildApiUrl('folders.entity', { folderId });
        return this.$http.patch(url, data).then(responseDataExtractor);
    }

    remove(folderId) {
        const url = Utils.buildApiUrl('folders.entity', { folderId });
        return this.$http.delete(url).then(responseDataExtractor);
    }

    move(folderId, data) {
        const url = Utils.buildApiUrl('folders.move', { folderId });
        return this.$http.post(url, data).then(responseDataExtractor);
    }

}



// WEBPACK FOOTER //
// ./app/services/api/folders/folders.service.js